// Autogenerated from `packages/@members/copy/copy.generated/__copy__.ts.hbs`

import { toCopyComponent } from '@peloton/copy-generic/models';
import type { CopyHook } from '@peloton/copy-generic/models';
import toFormattedText from '@peloton/copy/toFormattedText';
import type { CopyIDs } from '../CopyIDs';
import { useAllCopy } from '../CopyProvider/CopyProvider';
import type { Achievements } from '../models.generated/Achievements';

export const useAchievements: CopyHook<CopyIDs<typeof Achievements>> = (id, values) => {
  const copy = useAllCopy();
  const value = copy?.achievementsCollection?.[id];

  if (!value) {
    console.error(`No copy found for id ${id}`);
    return '';
  }

  return toFormattedText(value, values) as string;
};

export const AchievementsCopy = toCopyComponent(useAchievements);
